import React, { useState, useRef, useEffect } from "react";
import DownTriangle from "../assets/images/icon/Triangle.png";

const CustomDropdown = ({
  item,
  groups,
  handleGroupChange,
  isDropdownLoading,
  setIsDropdownLoading,
  lang = "EN",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [openAbove, setOpenAbove] = useState(false);
  const dropdownRef = useRef(null);

  const isLoading = Boolean(
    isDropdownLoading &&
      (isDropdownLoading === item._id ||
        isDropdownLoading === item.id ||
        String(isDropdownLoading) === String(item._id))
  );

  const toggleDropdown = () => {
    if (isLoading) return;
    if (!isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setOpenAbove(spaceBelow < 160);
    }
    setIsOpen((prev) => !prev);
  };

  const handleOptionClick = (groupId) => {
    handleGroupChange(item, groupId);
    setIsOpen(false);
  };

  const selectedGroupName =
    item.trainingGroupId?.groupName || (lang === "ES" ? "Seleccione un grupo" : "Select a group");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative inline-block w-full max-w-[200px]">
      {/* Trigger */}
      <div
        onClick={toggleDropdown}
        className={`flex justify-between items-center gap-2 cursor-pointer w-full bg-[#F0EEF8] rounded-lg px-3 py-2 border border-primary/20 hover:border-primary transition-colors ${
          isLoading ? "opacity-90 cursor-not-allowed" : ""
        }`}
      >
        {isLoading ? (
          <div className="flex items-center gap-2 py-0.5">
            <span className="w-4 h-4 border-2 border-primary/30 border-t-primary rounded-full animate-spin inline-block flex-shrink-0" />
            <span className="text-xs font-roboto text-primary/70 font-medium truncate">
              {lang === "ES" ? "Actualizando..." : "Updating..."}
            </span>
          </div>
        ) : (
          <div className="text-sm font-roboto text-primary font-medium truncate">
            {selectedGroupName}
          </div>
        )}
        <div className="w-4 h-4 flex-shrink-0 opacity-70">
          <img src={DownTriangle} alt="DownTriangle" className="w-full h-full" />
        </div>
      </div>

      {/* Menu — absolute relative to this wrapper */}
      {!isLoading && isOpen && (
        <ul
          className={`absolute left-0 w-full bg-white border border-primary/20 rounded-xl shadow-lg overflow-y-auto z-[9999] max-h-[160px] ${
            openAbove ? "bottom-full mb-1" : "top-full mt-1"
          }`}
        >
          {groups
            .filter((group) => group.groupName !== item?.trainingGroupId?.groupName)
            .map((group) => (
              <li
                key={group._id}
                className="py-2 px-3 cursor-pointer text-sm font-roboto text-gray-700 hover:bg-[#F0EEF8] hover:text-primary transition-colors duration-150"
                onClick={() => handleOptionClick(group._id)}
              >
                {group.groupName}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;

